<template>
  <v-dialog
    v-model="alertaComparte.estatus"
    max-width="420"
    width="90%"
  >
    <v-card class="comparte-card rounded-xl overflow-hidden">
      <div class="comparte-hero">
        <v-btn
          icon
          small
          class="comparte-close"
          @click="cerrarDialogo"
        >
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>

        <div class="hero-kicker">Promoción</div>
        <div class="hero-title">¡Comparte y gana!</div>
        <div class="hero-period">
          <v-icon small color="white" class="mr-1">mdi-calendar-range</v-icon>
          20 de agosto al 20 de septiembre
        </div>
      </div>

      <v-card-text class="pt-5 pb-2 px-5">
        <div class="section-label">Tarifas por folio</div>

        <div class="tarifa-card mb-3">
          <div class="tarifa-icon">
            <v-icon color="white">mdi-account</v-icon>
          </div>
          <div class="tarifa-copy">
            <div class="tarifa-name">Presencial</div>
            <div class="tarifa-hint">Adultos · por cada folio</div>
          </div>
          <div class="tarifa-amount">$500</div>
        </div>

        <div class="tarifa-card">
          <div class="tarifa-icon">
            <v-icon color="white">mdi-laptop</v-icon>
          </div>
          <div class="tarifa-copy">
            <div class="tarifa-name">Online</div>
            <div class="tarifa-hint">Por cada folio</div>
          </div>
          <div class="tarifa-amount">$250</div>
        </div>

        <p class="info-note mt-4 mb-0">
          Comparte tu enlace. Cuando tu recomendado se inscriba y liquide, verás la bonificación en Recomendados.
        </p>

        <v-alert
          v-if="copiado"
          dense
          text
          color="success"
          class="mb-0 mt-3"
        >
          No se abrió el menú de compartir. El enlace quedó copiado; pégalo en WhatsApp.
        </v-alert>
        <v-alert
          v-if="errorShare"
          dense
          text
          color="error"
          class="mb-0 mt-3"
        >
          {{ errorShare }}
        </v-alert>
      </v-card-text>

      <v-card-actions class="px-5 pb-5 pt-3 d-block">
        <v-btn
          block
          rounded
          dark
          large
          depressed
          color="#db0212"
          class="text-none font-weight-bold"
          :loading="compartiendo"
          @click="compartirEnlace"
        >
          <v-icon left>mdi-share-variant</v-icon>
          Compartir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { Clipboard } from '@capacitor/clipboard'
import { sesionReferralDesdeGetters } from '@/referrals/sesion'

export default {
  props: ['alertaComparte'],

  data () {
    return {
      copiado: false,
      compartiendo: false,
      errorShare: '',
    }
  },

  computed: {
    ...mapGetters('login', [
      'getUsuarioLMS',
      'getEscuela',
      'getLogeadoLMS',
      'getDatosUsuarioLMS',
    ]),

    sesionReferral () {
      return sesionReferralDesdeGetters({
        logeado: this.getLogeadoLMS,
        usuario: this.getUsuarioLMS,
        datosUsuario: this.getDatosUsuarioLMS,
        escuela: this.getEscuela,
      })
    },
  },

  methods: {
    mensajeShare (shareUrl) {
      return [
        '⚡ Hola, te quiero recomendar Fast para que estudies inglés como yo 🇺🇸',
        '',
        'Pensé en ti para empezar a estudiar inglés en la misma escuela. Además, por ir de mi parte puedes recibir una beca especial 🎓 ⚡',
        '',
        'Te dejo mi link para que te den info de precios y de la beca 👇',
        '',
        shareUrl,
        '',
        '🙏 No borres el mensaje predeterminado, porfa, así sabrán que yo te recomendé.',
      ].join('\n')
    },

    fueCancelado (error) {
      const msg = String((error && error.message) || error || '').toLowerCase()
      const name = String((error && error.name) || '')
      return name === 'AbortError'
        || msg.includes('cancel')
        || msg.includes('share canceled')
        || msg.includes('share cancelled')
    },

    async abrirShareNativo (mensaje) {
      try {
        const { Share } = await import('@capacitor/share')
        await Share.share({
          title: 'Comparte y gana',
          text: mensaje,
          dialogTitle: 'Compartir enlace',
        })
        return 'shared'
      } catch (e) {
        if (this.fueCancelado(e)) return 'cancelled'
      }
      if (typeof navigator !== 'undefined' && navigator.share) {
        try {
          await navigator.share({
            title: 'Comparte y gana',
            text: mensaje,
          })
          return 'shared'
        } catch (e) {
          if (this.fueCancelado(e)) return 'cancelled'
        }
      }
      return 'unavailable'
    },

    cerrarDialogo () {
      this.alertaComparte.estatus = false
      this.copiado = false
      this.errorShare = ''
    },

    async compartirEnlace () {
      if (!this.sesionReferral.ok) return

      this.errorShare = ''
      this.copiado = false
      this.compartiendo = true

      try {
        const response = await this.$http.post('api/referrals', {
          id_lms: this.sesionReferral.idLms,
        })
        const shareUrl = response.body && response.body.share_url
        if (!shareUrl) {
          throw new Error('No se recibió el enlace')
        }

        const mensaje = this.mensajeShare(shareUrl)
        const resultado = await this.abrirShareNativo(mensaje)
        if (resultado === 'shared') {
          this.cerrarDialogo()
          this.$emit('compartido')
          return
        }
        if (resultado === 'cancelled') return

        await Clipboard.write({ string: mensaje })
        this.copiado = true
      } catch (error) {
        const msg = (error && error.body && error.body.message)
          || (error && error.message)
          || 'No se pudo generar el enlace de recomendación.'
        this.errorShare = msg
      } finally {
        this.compartiendo = false
      }
    },
  },
}
</script>

<style scoped>
.comparte-hero {
  position: relative;
  padding: 28px 24px 22px;
  color: #fff;
  background: linear-gradient(135deg, #ff4d4d 0%, #db0212 100%);
}

.comparte-close {
  position: absolute;
  top: 8px;
  right: 8px;
}

.hero-kicker {
  font-size: 12px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  opacity: 0.85;
  font-weight: 600;
}

.hero-title {
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
  margin: 4px 0 10px;
}

.hero-period {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
}

.section-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 12px;
}

.tarifa-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f7f8fa;
  border-radius: 14px;
  padding: 12px 14px;
}

.tarifa-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #db0212;
}

.tarifa-copy {
  flex: 1;
  min-width: 0;
}

.tarifa-name {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.25;
}

.tarifa-hint {
  font-size: 12px;
  color: #6b7280;
}

.tarifa-amount {
  font-size: 20px;
  font-weight: 800;
  color: #111827;
  letter-spacing: -0.4px;
}

.info-note {
  font-size: 12px;
  line-height: 1.45;
  color: #6b7280;
}
</style>
